/* Scroll-reveal: add .is-visible to .reveal elements as they enter the viewport.
   Fully bypassed (elements shown immediately) under prefers-reduced-motion. */
(function () {
  function showAll() {
    document.querySelectorAll(".reveal").forEach((el) => el.classList.add("is-visible"));
  }

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced || !("IntersectionObserver" in window)) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", showAll);
    } else {
      showAll();
    }
    return;
  }

  const io = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        obs.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
  );

  function observe() {
    document.querySelectorAll(".reveal:not(.is-visible)").forEach((el) => io.observe(el));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observe);
  } else {
    observe();
  }

  // Re-scan when the Theme Editor injects/updates a section.
  document.addEventListener("shopify:section:load", observe);
})();
